import { ResetPasswordForm } from '@/components/auth/ResetPasswordForm';

export function ResetPassword() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <ResetPasswordForm />
    </div>
  );
}